import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-xml';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/ext-language_tools';

const XMLEditor = forwardRef(({ value, onChange }, ref) => {
    const editorRef = useRef(null);

    useImperativeHandle(ref, () => ({
        insertTagAtCursor: (tag) => {
            if (!editorRef.current) return;
            const editor = editorRef.current.editor;
            const cursorPos = editor.selection.getCursor();
            editor.session.insert(cursorPos, tag);
        },
        insertTagAtBottom: (tag) => {
            if (!editorRef.current) return;
            const editor = editorRef.current.editor;
            const lastLine = editor.session.getLength();
            const bottomPosition = { row: lastLine, column: 0 };
            editor.session.insert(bottomPosition, tag);
        },
        focusEditor: () => {
            if (!editorRef.current) return;
            editorRef.current.editor.focus();
        },
    }));

    return (
        <AceEditor
            ref={editorRef}
            mode="xml"
            theme="github"
            onChange={onChange}
            value={value}
            name="xml-editor"
            editorProps={{ $blockScrolling: true }}
            setOptions={{
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true,
                enableSnippets: true,
                showLineNumbers: true,
                tabSize: 2,
            }}
            width="100%"
            height="400px"
        />
    );
});

export default XMLEditor;